import type { AppDataState } from "../api/useAppData";
import { relativeAge } from "../lib/dates";

export default function DataFreshnessBanner({
  state,
}: {
  state: AppDataState;
}) {
  const { data, error, refetch } = state;

  if (!data && error === "not-ready") {
    return (
      <div className="banner warn" role="status">
        No sweepstake data has been loaded yet.
        <button type="button" onClick={refetch}>
          Try again
        </button>
      </div>
    );
  }

  if (!data && error === "network") {
    return (
      <div className="banner error" role="alert">
        Couldn't load sweepstake data.
        <button type="button" onClick={refetch}>
          Try again
        </button>
      </div>
    );
  }

  if (!data) return null;

  if (error === "network") {
    return (
      <div className="banner warn" role="status">
        Couldn't refresh — showing the last known data.
        <button type="button" onClick={refetch}>
          Try again
        </button>
      </div>
    );
  }

  if (data.dataSourceStatus === "stale" && data.lastUpdated) {
    return (
      <div className="banner warn" role="status">
        Data may be stale — last updated {relativeAge(data.lastUpdated)}.
      </div>
    );
  }

  return null;
}
